import { ColumnsType } from "antd/es/table";
import { Report } from "@types";
import { Translation } from "react-i18next";
import { examPeriodHasPassedFormat } from "./helpers";
import dayjs from "dayjs";
import { ReportTableActions } from "@components";

export const reportsTable: ColumnsType<Report> = [
    {
        title:  <Translation>{(t) => `${t("table.exam")}`}</Translation>,
        dataIndex: "title",
        key: "exam",
    },

    {
        title: <Translation>{(t) => `${t("table.firstName")}`}</Translation>,
        dataIndex: "userExamineeFirstName",
        key: "firstName",
    },
    {
        title: <Translation>{(t) => `${t("table.lastName")}`}</Translation>,
        dataIndex: "userExamineeLastName",
        key: "lastName",
    },
    {
        title:  <Translation>{(t) => `${t("table.date")}`}</Translation>,
        dataIndex: "date",
        key: "date",
        render(value) {
            return dayjs(value).format("DD.MM.YYYY");
        }
    },
    {
        title: <Translation>{(t) => `${t("table.status")}`}</Translation>,
        dataIndex: "examInstanceState",
        key: "status",
        render(_, record) {
           return examPeriodHasPassedFormat(record);
        }
    },
    {
        title: <Translation>{(t) => `${t("table.actions")}`}</Translation>,
        key: "grading",
        render(_, record) {
            return <ReportTableActions report={record}/>
        }
    }
]